import styled from 'styled-components';

export const WrapperModal = styled.div`
  .modal {
    position: fixed; /* Stay in place */
    z-index: 10;
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  /* Modal Content/Box */
  .modal-content {
    background-color: #fefefe;
    margin: 0 auto;
    border: 1px solid #888;
    border-radius: 5px;
    min-width: 37%;
    position: relative;
  }

  .divfooter button {
    margin: 0 auto;
    padding: 0.75rem 3.5rem;
  }

  .barraTop button {
    position: absolute;
    right: 0;
    top: 10px;
    display:flex;
    justify-content:flex-end
  }

  .modalCard {
    padding: 1rem !important;
  }

  .titulo,
  .modalCard > div {
    border: 0 !important;
  }

  .cardSiguiente {
    padding-top: 0 !important;
    padding-bottom: 1.5rem !important;
  }

  .siguiente button span {
    text-decoration: none !important;
  }

  .siguiente {
    display: flex;
    justify-content: flex-end;
    padding-right: 1rem;
  }

  .siguiente button::after {
    content: '>';
    font-size: 27px;
    font-weight: 500;
    position: relative;
    left: 10px;
    top: -2px;
  }

  .tituloModal {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 0.5rem !important;
  }

  .botonTerminar {
    color: white !important;
    background-color: rgb(232, 30, 43) !important;
    min-width: 180px;
    -webkit-box-pack: center;
    justify-content: center;
    border: 1px solid #e81e2b;
    position: relative;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    height: 48px;
    font-weight: 500;
    font-family: 'Ubuntu';
    font-size: 0.875rem;
    align-items: center;
    display: flex;
    box-shadow: 0 2px 4px 0 rgb(30 30 30 / 35%);
    outline: none !important;
    transition: background 0.3s ease;
  }

  .botonTerminar:hover, .botonTerminar:active {
    background-color: #e81e2b;
    color: #fff;
  }

  .botonTerminar:disabled {
    background-color: #d4d4d4 !important;
    color: #ffffff;
    box-shadow: none;
  }

  .botonTerminar:after {
    content: none !important;
  }

  .botonContinuar:disabled {
    background-color: #fefefe;
    color: #d4d4d4;
  }

  .iconUser {
    min-width: 37.5%;
  }

  .iconUserContainer {
    justify-content: center;
    display: flex;
  }

  .titulo {
    color: #2e2e2e;
    text-align: center;
    font-size: 19px;
    font-weight: 600;
    line-height: 28px;
    padding-top: 20px;
    padding-bottom: 10px;
  }

  .subtitulo {
    color: #2e2e2e;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    padding-bottom: 0px;
    line-height: 22px;
    margin: 0 auto;
  }

  .subtitulo {
    padding-bottom: 30px
  }

  .retomarFormBoton {
    padding-left: 0px
  }

  .retomarFormBoton::before {
    /* content: '<'; */
    font-size: 27px;
    font-weight: 500;
    position: relative;
    left: -10px;
    top: -2px;
  }

  .descriptionBold {
    font-weight: 700;
  }

  .retomarFormBoton::after {
    content: unset !important;
  }

  .volver {
    justify-content: space-between;
    display: flex;
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 10px;
    padding-right: 10px;
  }
  
  .subtitulo p {
    border-bottom: 1px solid #ddd;    
    padding-bottom: 25px;

  }

  .barraTop > button:disabled, .retomarFormBoton:disabled {
    color: #e81e2b !important;
    background-color: #fff !important;
  }

  @media (max-width: 426px) {
    .barraTop button {
      margin: unset;
      position: unset;
      top: unset;
    }

    .divfooter button {
      margin: 0 auto;
      padding: 0.75rem 3.5rem;
      width: 60%;
    }

    .modalCard {
      display: flex;
      text-align: initial;
    }

    .modal-content {
      width: 100%;
    }

    .modal-content {
      position: initial;
      max-width: 100%;
    }
    
    .titulo {
      line-height: 26px !important;
    }

    .tituloModal {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      padding: 0;
      padding-top: 1rem;
      padding-bottom: 0 !important;
      margin: 0;
    }

    .iconPersonSuccessImg {
      width: 50%;
    }

    .volver {
      padding-bottom: 10px;
    }

  }

  @media (max-width: 376px) {

    .divfooter button {
      margin: 0 auto;
      padding: 0.75rem 3.5rem;
      width: 65%;
    }

    .modalCard {
      display: flex;
      text-align: initial;
    }

    .modal-content {
      position: initial;
      max-width: 100%;
    }

    .BoikB .modal button {
      margin-left: 24px;
    }
  }

  @media (max-width: 320px) {
    .barraTop button {
      margin: -10px -119px;
      position: initial;
      top: calc(50% - 203px);
      left: calc(50% + 242px);
      margin-left: -19px;
    }

    .divfooter button {
      margin: 0 auto;
      padding: 0.75rem 3.5rem;
      width: 75%;
    }

    .modalCard {
      display: flex;
      text-align: initial;
    }

    .modal-content {
      position: initial;
      max-width: 100%;
    }
  }
`;

export default WrapperModal;
